export default "__VITE_ASSET__a56459e1__"